import styled from 'styled-components';
import { breakpoints } from 'src/styles/theme';
import { rem } from 'polished';
import NotReadyToBuyOnlineTemplate from './NotReadyToBuyOnlineTemplate';
export const NotReadyToBuyOnlineStyled = styled(NotReadyToBuyOnlineTemplate)`
    display: flex;
    flex-direction: column;
    background: ${({ theme }) => theme.colors.grey6};
    padding: ${rem('24px')};

    @media (min-width: ${breakpoints.sm}px) {
        margin: 0 ${rem(10)} 0 ${rem(10)};
        border-radius: ${rem('12px')};
    }

    .title {
        font-size: ${rem('22px')};
        font-weight: bold;
        line-height: 1.18;
    }

    .container {
        display: flex;
        justify-content: space-between;
        flex-direction: column;

        @media (min-width: ${breakpoints.sm}px) {
            flex-direction: row;
        }

        .wrapper {
            display: flex;
            flex-direction: column;
            padding: ${rem('26px')} 0 0 0;
            max-width: ${rem('440px')};
            width: 100%;

            .innerTitle {
                display: flex;
                align-items: flex-end;

                .titleContent {
                    margin-left: ${rem('48px')};
                    margin-bottom: ${rem('8px')};
                    font-size: ${rem('16px')};
                    font-weight: bold;
                }
                .icon {
                    width: 40px;
                    height: 40px;
                    position: absolute;

                    .icon-wrapper,
                    svg {
                        width: inherit;
                        height: inherit;
                    }
                }
            }

            .innerContent {
                display: flex;
                flex-direction: column;
                margin-left: ${rem('48px')};
                font-size: ${rem('16px')};
                line-height: 1.38;
                color: ${({ theme }) => theme.colors.grey5};

                .linkButton {
                    margin-top: ${rem('10px')};
                    .linkText {
                        font-size: ${rem('16px')};
                        margin-right: ${rem('6px')};
                        color: ${({ theme }) => theme.colors.red};
                    }

                    .icon-wrapper {
                        svg path {
                            fill: ${({ theme }) => theme.colors.red} !important;
                            stroke: ${({ theme }) => theme.colors.red} !important;
                        }
                    }

                    &:hover {
                        .icon-wrapper {
                            svg path {
                                fill: ${({ theme }) => theme.colors.grey5} !important;
                                stroke: ${({ theme }) => theme.colors.grey5} !important;
                            }
                        }
                    }
                }

                .innerContentTxt {
                    display: flex;
                    flex-direction: column;

                    .contentItem {
                        margin-top: ${rem('8px')};
                    }
                }
            }
        }
    }
`;
